import { useStaticQuery, graphql } from "gatsby"

export const useNewYearImages = () => {
  const query = useStaticQuery(graphql`
    query {
      #OurTeam
      hero: file(relativePath: { eq: "img/Blog/nowy-rok/nowy-rok.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1600, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      thumb: file(relativePath: { eq: "img/Blog/nowy-rok/thumb.png" }) {
        childImageSharp {
          fluid(maxWidth: 700, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      event: file(relativePath: { eq: "img/Blog/nowy-rok/nowy-rok.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
            ...GatsbyImageSharpFluidLimitPresentationSize
          }
        }
      }
      #END
    }
  `)
  return query
}
